import { useState, useEffect } from 'react';
import { authService } from '../services/api';
import { AuthState } from '../types/auth';

export function useAuth() {
  const [state, setState] = useState<AuthState>({
    user: null,
    loading: true,
    error: null
  });

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await authService.getUser();
        setState({
          user,
          loading: false,
          error: null
        });
      } catch (error) {
        setState({
          user: null,
          loading: false,
          error: error as Error
        });
      }
    };

    checkAuth();
  }, []);

  const logout = async () => {
    try {
      await authService.logout();
      setState({
        user: null,
        loading: false,
        error: null
      });
    } catch (error) {
      setState({
        ...state,
        error: error as Error
      });
    }
  };

  return {
    ...state,
    logout
  };
}